/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';

export const createClipsFromSubtitleSearchV1DataSchema = z.object({
  created: z.number(),
  skipped: z.number(),
});

export type ICreateClipsFromSubtitleSearchV1Data = z.infer<
  typeof createClipsFromSubtitleSearchV1DataSchema
>;

export const createClipsFromSubtitleSearchV1ResponseSchema = createApiResponseSchema(
  createClipsFromSubtitleSearchV1DataSchema,
) as z.ZodSchema<IAPI<ICreateClipsFromSubtitleSearchV1Data>>;

export type ICreateClipsFromSubtitleSearchV1Response = IAPI<ICreateClipsFromSubtitleSearchV1Data>;
